module.exports = __webpack_public_path__ + "img/dooball.d66ac89e.png";